export enum ActionNames {
    UPDATE_META_DESCRIPTION = 'META:UPDATE_DESCRIPTION',
    UPDATE_META_TITLE = 'META:UPDATE_TITLE',
    UPDATE_META_PAGINATION = 'META:UPDATE_PAGINATION',
    UPDATE_ROUTER_CURRENT_URL = 'ROUTER:UPDATE_CURRENT_URL',
    UPDATE_CURRENT_ROUTE_NAME = 'ROUTER:UPDATE_CURRENT_ROUTE_NAME',
    UPDATE_OG_TYPE = 'OG:UPDATE_TYPE',
    UPDATE_OG_URL = 'OG:UPDATE_URL',
    UPDATE_META_ROBOTS = 'META:UPDATE_ROBOTS'
}
